var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCardflip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.707 22.293C14.5184 22.1108 14.2658 22.01 14.0036 22.0123C13.7414 22.0146 13.4906 22.1197 13.3052 22.3052C13.1198 22.4906 13.0146 22.7414 13.0123 23.0036C13.01 23.2658 13.1108 23.5184 13.293 23.707L15.578 25.992C7.158 25.907 2 23.348 2 21.5C2 20.991 2.4 20.428 3.146 19.877C3.0535 19.5936 3.00428 19.298 3 19V17.6C1.153 18.617 0 19.923 0 21.5C0 25.648 7.958 27.915 15.593 27.993L13.293 30.293C13.1975 30.3852 13.1213 30.4956 13.0689 30.6176C13.0165 30.7396 12.9889 30.8708 12.9877 31.0036C12.9866 31.1364 13.0119 31.268 13.0622 31.3909C13.1125 31.5138 13.1867 31.6255 13.2806 31.7194C13.3745 31.8133 13.4861 31.8875 13.609 31.9378C13.7319 31.9881 13.8636 32.0134 13.9964 32.0122C14.1292 32.0111 14.2604 31.9835 14.3824 31.9311C14.5044 31.8787 14.6148 31.8025 14.707 31.707L18.707 27.707C18.8945 27.5194 18.9998 27.2651 18.9998 27C18.9998 26.7348 18.8945 26.4805 18.707 26.293L14.707 22.293Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0001 17.6V19C28.9958 19.298 28.9466 19.5936 28.8541 19.877C29.6001 20.428 30.0001 20.991 30.0001 21.5C30.0001 22.7 27.7551 24.42 22.8261 25.378C22.5828 25.4261 22.366 25.5629 22.2179 25.7618C22.0698 25.9607 22.0009 26.2076 22.0246 26.4545C22.0483 26.7013 22.1628 26.9306 22.346 27.0977C22.5293 27.2649 22.7681 27.358 23.0161 27.359C23.0805 27.3593 23.1448 27.3533 23.2081 27.341C28.7131 26.271 32.0001 24.087 32.0001 21.5C32.0001 19.922 30.8471 18.616 29.0001 17.6Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H14V11H9V9Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 7H7L7 19H25V7ZM7 5C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H25C26.1046 21 27 20.1046 27 19V7C27 5.89543 26.1046 5 25 5H7Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardflip);
export default __webpack_public_path__ + "static/media/icon-cardflip.978303522546db84f75dfcb01107b291.svg";
export { ForwardRef as ReactComponent };